<template>
    <div :class="['block', additionalInfoHeading && 'additionalInfoBlock']" :style="{ width: width }">
        <i v-if="!hideIcon" class="icon fal fa-info-circle"></i>

        <h3 class="text-center" v-if="additionalInfoHeading">
            {{ additionalInfoHeading }}
        </h3>

        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        width: {
            type: String,
            default: '100%',
        },
        hideIcon: {
            type: Boolean,
            default: false,
        },
        additionalInfoHeading: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';

.block {
    background: #f4f5f6;
    color: #525252;
    font-size: rem(13px);
    margin-bottom: 32px;
    margin-left: auto;
    margin-right: auto;
    padding: 14px 14px 14px 40px;
    position: relative;
    text-align: left;

    h3 {
        font-size: rem(20px);
    }

    .icon {
        color: #3380e3;
        font-size: rem(18px);
        left: 14px;
        position: absolute;
        top: 16px;
    }
}
</style>

<style lang="scss">
@import '~scss/settings/responsive';

.additionalInfoBlock {
    padding: 14px !important;
    margin: 32px 0px 0px;
    max-width: 430px;

    ul {
        list-style-type: circle;
        margin-left: 20px;

        @media screen and (min-width: $bp-medium) {
            margin-left: 30px;
        }
    }
}
</style>
